import { useState, useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

type TestimonialCategory = 'all' | 'thinning' | 'scalp' | 'damage' | 'color' | 'texture';

interface Testimonial {
  id: number;
  name: string;
  location: string;
  category: TestimonialCategory[];
  problem: string;
  solution: string;
  result: string;
  image: string;
  rating: number;
}

export default function Testimonials() {
  const [activeCategory, setActiveCategory] = useState<TestimonialCategory>('all');

  const testimonials: Testimonial[] = [
    {
      id: 1,
      name: 'Sarah Mitchell',
      location: 'United Kingdom',
      category: ['thinning', 'scalp'],
      problem: 'Severe hair thinning and itchy scalp',
      solution: 'Scalp therapy treatment series combined with targeted product recommendations',
      result: 'After three months of treatment, my hair density improved significantly and the itching completely stopped. I finally feel confident again.',
      image: 'https://public.readdy.ai/ai/img_res/c5f9a04ab60f5f4266eacff062ef31a2.jpg',
      rating: 5
    },
    {
      id: 2,
      name: 'Michael Chen',
      location: 'Singapore',
      category: ['scalp'],
      problem: 'Persistent dandruff and oily scalp',
      solution: 'Professional scalp analysis and customized treatment protocol',
      result: 'The dandruff disappeared within weeks. The therapist truly understood my scalp condition and provided solutions that actually work.',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20asian%20man%20with%20healthy%20hair%20confident%20smile%20natural%20lighting%20simple%20clean%20white%20background%20minimal%20aesthetic%20premium%20quality&width=400&height=400&seq=test002&orientation=squarish',
      rating: 5
    },
    {
      id: 3,
      name: 'Emma Rodriguez',
      location: 'Spain',
      category: ['damage', 'texture'],
      problem: 'Extremely damaged hair from years of bleaching',
      solution: 'Hair repair treatment series with Olaplex and keratin smoothing',
      result: 'My hair went from straw-like to silky smooth. I never thought it could be saved, but the expertise here is incredible.',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20woman%20with%20smooth%20shiny%20healthy%20hair%20natural%20light%20simple%20clean%20white%20background%20minimal%20aesthetic%20premium%20quality&width=400&height=400&seq=test003&orientation=squarish',
      rating: 5
    },
    {
      id: 4,
      name: 'James Thompson',
      location: 'Australia',
      category: ['thinning'],
      problem: 'Early stage hair loss and thinning crown',
      solution: 'Scalp therapy combined with professional product regimen',
      result: 'The thinning has slowed down dramatically and I can see new growth. The personalized approach made all the difference.',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20man%20with%20healthy%20hair%20confident%20expression%20natural%20lighting%20simple%20clean%20white%20background%20minimal%20aesthetic%20premium%20quality&width=400&height=400&seq=test004&orientation=squarish',
      rating: 5
    },
    {
      id: 5,
      name: 'Yuki Tanaka',
      location: 'Japan',
      category: ['color', 'damage'],
      problem: 'Faded color and dry damaged ends',
      solution: 'Color correction with Wella Professionals and deep repair treatments',
      result: 'The color is vibrant and my hair feels healthier than before I colored it. True professional work.',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20asian%20woman%20with%20beautiful%20colored%20hair%20natural%20light%20simple%20clean%20white%20background%20minimal%20aesthetic%20premium%20quality&width=400&height=400&seq=test005&orientation=squarish',
      rating: 5
    },
    {
      id: 6,
      name: 'Sophie Laurent',
      location: 'France',
      category: ['texture', 'damage'],
      problem: 'Unmanageable frizzy hair',
      solution: 'Keratin smoothing treatment with Moroccanoil maintenance',
      result: 'My morning routine went from 45 minutes to 10 minutes. The frizz is gone and my hair is so manageable now.',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20woman%20with%20smooth%20straight%20hair%20elegant%20natural%20lighting%20simple%20clean%20white%20background%20minimal%20aesthetic%20premium%20quality&width=400&height=400&seq=test006&orientation=squarish',
      rating: 5
    },
    {
      id: 7,
      name: 'David Kim',
      location: 'South Korea',
      category: ['scalp'],
      problem: 'Sensitive scalp and irritation from products',
      solution: 'Scalp therapy with Aveda botanical treatments',
      result: 'Finally found someone who understands sensitive scalp issues. The natural approach worked perfectly for me.',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20korean%20man%20with%20healthy%20hair%20calm%20expression%20natural%20lighting%20simple%20clean%20white%20background%20minimal%20aesthetic%20premium%20quality&width=400&height=400&seq=test007&orientation=squarish',
      rating: 5
    },
    {
      id: 8,
      name: 'Isabella Rossi',
      location: 'Italy',
      category: ['color', 'texture'],
      problem: 'Wanted to go lighter without damage',
      solution: 'Gradual lightening process with Redken and bond protection',
      result: 'Achieved my dream blonde without compromising hair health. The patience and expertise shown throughout the process was exceptional.',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20woman%20with%20beautiful%20blonde%20hair%20radiant%20smile%20natural%20lighting%20simple%20clean%20white%20background%20minimal%20aesthetic%20premium%20quality&width=400&height=400&seq=test008&orientation=squarish',
      rating: 5
    },
    {
      id: 9,
      name: 'Marcus Johnson',
      location: 'United States',
      category: ['thinning', 'scalp'],
      problem: 'Receding hairline and scalp inflammation',
      solution: 'Comprehensive scalp therapy and Philip Kingsley trichological products',
      result: 'The inflammation is completely gone and my hairline has stabilized. I wish I had found this place years ago.',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20man%20with%20healthy%20hair%20confident%20professional%20natural%20lighting%20simple%20clean%20white%20background%20minimal%20aesthetic%20premium%20quality&width=400&height=400&seq=test009&orientation=squarish',
      rating: 5
    },
    {
      id: 10,
      name: 'Olivia Zhang',
      location: 'Canada',
      category: ['damage', 'texture'],
      problem: 'Heat damage from daily styling',
      solution: 'Sachajuan repair treatments and styling technique education',
      result: 'Not only did my hair recover, but I learned how to style it properly without causing damage. Life-changing advice.',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20woman%20with%20healthy%20shiny%20hair%20warm%20smile%20natural%20lighting%20simple%20clean%20white%20background%20minimal%20aesthetic%20premium%20quality&width=400&height=400&seq=test010&orientation=squarish',
      rating: 5
    },
    {
      id: 11,
      name: 'Thomas Mueller',
      location: 'Germany',
      category: ['scalp'],
      problem: 'Chronic dry scalp and flaking',
      solution: 'Scalp therapy with hydrating treatments',
      result: 'The flaking stopped after just two sessions. Finally someone who treated the cause, not just the symptoms.',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20man%20with%20healthy%20hair%20satisfied%20expression%20natural%20lighting%20simple%20clean%20white%20background%20minimal%20aesthetic%20premium%20quality&width=400&height=400&seq=test011&orientation=squarish',
      rating: 5
    },
    {
      id: 12,
      name: 'Priya Sharma',
      location: 'India',
      category: ['texture', 'damage'],
      problem: 'Coarse texture and split ends',
      solution: 'Keratin treatment and Kérastase maintenance routine',
      result: 'My hair has never been this soft and smooth. The transformation is remarkable and the results last.',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20indian%20woman%20with%20beautiful%20smooth%20hair%20elegant%20natural%20lighting%20simple%20clean%20white%20background%20minimal%20aesthetic%20premium%20quality&width=400&height=400&seq=test012&orientation=squarish',
      rating: 5
    }
  ];

  const categories = [
    { id: 'all', label: 'All Stories' },
    { id: 'thinning', label: 'Hair Thinning' },
    { id: 'scalp', label: 'Scalp Issues' },
    { id: 'damage', label: 'Hair Damage' },
    { id: 'color', label: 'Color Concerns' },
    { id: 'texture', label: 'Texture & Frizz' }
  ];

  const filteredTestimonials = activeCategory === 'all' 
    ? testimonials 
    : testimonials.filter(t => t.category.includes(activeCategory));

  // SEO: Update page title and meta description
  useEffect(() => {
    document.title = 'Client Testimonials & Success Stories | Muses Hair CWB';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Real client success stories and testimonials from Muses Hair CWB. Discover how professional scalp therapy and hair treatments have transformed clients dealing with hair thinning, scalp issues, damage, and more.');
    }
  }, []);

  // SEO: Add Schema.org JSON-LD
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": `${siteUrl}/testimonials#webpage`,
          "url": `${siteUrl}/testimonials`,
          "name": "Client Testimonials & Success Stories | Muses Hair CWB",
          "description": "Real client success stories and testimonials from Muses Hair CWB. Discover how professional scalp therapy and hair treatments have transformed clients dealing with hair thinning, scalp issues, damage, and more.",
          "isPartOf": {
            "@type": "WebSite",
            "@id": `${siteUrl}/#website`,
            "url": siteUrl,
            "name": "Muses Hair CWB"
          },
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": siteUrl
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Testimonials",
                "item": `${siteUrl}/testimonials`
              }
            ]
          }
        },
        {
          "@type": "HairSalon",
          "@id": `${siteUrl}/#hairsalon`,
          "name": "Muses Hair CWB",
          "url": siteUrl,
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "5",
            "reviewCount": "12",
            "bestRating": "5",
            "worstRating": "5"
          },
          "review": [
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Sarah Mitchell"
              },
              "reviewRating": {
                "@type": "Rating",
                "ratingValue": "5",
                "bestRating": "5"
              },
              "reviewBody": "After three months of treatment, my hair density improved significantly and the itching completely stopped. I finally feel confident again."
            },
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Michael Chen"
              },
              "reviewRating": {
                "@type": "Rating",
                "ratingValue": "5",
                "bestRating": "5"
              },
              "reviewBody": "The dandruff disappeared within weeks. The therapist truly understood my scalp condition and provided solutions that actually work."
            },
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Emma Rodriguez"
              },
              "reviewRating": {
                "@type": "Rating",
                "ratingValue": "5",
                "bestRating": "5"
              },
              "reviewBody": "My hair went from straw-like to silky smooth. I never thought it could be saved, but the expertise here is incredible."
            },
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "James Thompson"
              },
              "reviewRating": {
                "@type": "Rating",
                "ratingValue": "5",
                "bestRating": "5"
              },
              "reviewBody": "The thinning has slowed down dramatically and I can see new growth. The personalized approach made all the difference."
            },
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Yuki Tanaka"
              },
              "reviewRating": {
                "@type": "Rating",
                "ratingValue": "5",
                "bestRating": "5"
              },
              "reviewBody": "The color is vibrant and my hair feels healthier than before I colored it. True professional work."
            },
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Sophie Laurent"
              },
              "reviewRating": {
                "@type": "Rating",
                "ratingValue": "5",
                "bestRating": "5"
              },
              "reviewBody": "My morning routine went from 45 minutes to 10 minutes. The frizz is gone and my hair is so manageable now."
            },
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "David Kim"
              },
              "reviewRating": {
                "@type": "Rating",
                "ratingValue": "5",
                "bestRating": "5"
              },
              "reviewBody": "Finally found someone who understands sensitive scalp issues. The natural approach worked perfectly for me."
            },
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Isabella Rossi"
              },
              "reviewRating": {
                "@type": "Rating",
                "ratingValue": "5",
                "bestRating": "5"
              },
              "reviewBody": "Achieved my dream blonde without compromising hair health. The patience and expertise shown throughout the process was exceptional."
            },
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Marcus Johnson"
              },
              "reviewRating": {
                "@type": "Rating",
                "ratingValue": "5",
                "bestRating": "5"
              },
              "reviewBody": "The inflammation is completely gone and my hairline has stabilized. I wish I had found this place years ago."
            },
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Olivia Zhang"
              },
              "reviewRating": {
                "@type": "Rating",
                "ratingValue": "5",
                "bestRating": "5"
              },
              "reviewBody": "Not only did my hair recover, but I learned how to style it properly without causing damage. Life-changing advice."
            },
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Thomas Mueller"
              },
              "reviewRating": {
                "@type": "Rating",
                "ratingValue": "5",
                "bestRating": "5"
              },
              "reviewBody": "The flaking stopped after just two sessions. Finally someone who treated the cause, not just the symptoms."
            },
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Priya Sharma"
              },
              "reviewRating": {
                "@type": "Rating",
                "ratingValue": "5",
                "bestRating": "5"
              },
              "reviewBody": "My hair has never been this soft and smooth. The transformation is remarkable and the results last."
            }
          ]
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    script.id = 'testimonials-schema';
    document.head.appendChild(script);

    return () => {
      const existingScript = document.getElementById('testimonials-schema');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <section className="pt-32 pb-16 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h1 className="text-5xl font-light mb-6" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              Client Success Stories
            </h1>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Real transformations from clients who found professional solutions to their hair and scalp concerns. 
              Each story represents a personalized approach to achieving healthy, beautiful hair.
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3 mb-16">
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setActiveCategory(cat.id as TestimonialCategory)}
                className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                  activeCategory === cat.id
                    ? 'bg-gray-900 text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {cat.label}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredTestimonials.map((testimonial) => (
              <div
                key={testimonial.id}
                className="bg-gray-50 rounded-lg p-8 hover:shadow-lg transition-shadow"
              >
                <div className="flex items-start gap-4 mb-6">
                  <div className="w-16 h-16 flex-shrink-0">
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="w-full h-full rounded-full object-cover"
                    />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-medium mb-1">{testimonial.name}</h3>
                    <p className="text-sm text-gray-500 mb-2">{testimonial.location}</p>
                    <div className="flex gap-1">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-yellow-500 text-sm"></i>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="space-y-4">
                  <div>
                    <h4 className="text-sm font-semibold text-gray-900 mb-2">The Problem</h4>
                    <p className="text-sm text-gray-600 leading-relaxed">{testimonial.problem}</p>
                  </div>

                  <div>
                    <h4 className="text-sm font-semibold text-gray-900 mb-2">The Solution</h4>
                    <p className="text-sm text-gray-600 leading-relaxed">{testimonial.solution}</p>
                  </div>

                  <div>
                    <h4 className="text-sm font-semibold text-gray-900 mb-2">The Result</h4>
                    <p className="text-sm text-gray-700 leading-relaxed italic">"{testimonial.result}"</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 px-6" style={{ backgroundColor: '#F3F0EB' }}>
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-light mb-6" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            Your Success Story Starts Here
          </h2>
          <p className="text-lg text-gray-700 mb-10 leading-relaxed">
            Every client's journey is unique. Whether you're dealing with hair thinning, scalp issues, damage, 
            or simply want to achieve your healthiest hair, we're here to create a personalized solution for you.
          </p>
          <button
            onClick={() => {
              const bookingSection = document.getElementById('booking-form');
              if (bookingSection) {
                bookingSection.scrollIntoView({ behavior: 'smooth' });
              } else {
                window.REACT_APP_NAVIGATE('/');
                setTimeout(() => {
                  const form = document.getElementById('booking-form');
                  if (form) form.scrollIntoView({ behavior: 'smooth' });
                }, 100);
              }
            }}
            className="bg-gray-900 text-white px-10 py-4 rounded-full text-base font-medium hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            Book Your Consultation
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
}